var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":_vm.title}},[_c('b-table',{ref:"table",attrs:{"items":_vm.$store.state.ServiceMod.services,"fields":_vm.fields,"hover":""},on:{"row-clicked":_vm.onRowClicked}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }